@if (cardType() === publicationsType.LATEST) {
  <a [href]="getUrl()" target="{{newTabLink() ? '_blank' : '_self' }}">
    <div [class.no-left-margin]="noLeftMargin()"
         class="publication-card flex row latest">
      <img [alt]="publicationData().title" [ngSrc]="thumbnailImage" height="128" width="91">
      <div class="flex-column">
        <div class="text-md text--semi-bold title">{{ publicationData().title }}</div>
        @if (hasDesc()) {
          <div class="text-sm description"
               [innerHTML]="publicationData().summary || publicationData().htmlDescription | removeHtml"></div>
        }
        <div class="date">{{ HELPER.formatDateWithLocalizedMonth(publicationData().publishDate) }}
        </div>
      </div>
    </div>
  </a>
} @else {
  <a [href]="getUrl()" target="{{newTabLink() ? '_blank' : '_self' }}">
    <div class="publication-card flex row related"
         [class.no-left-margin]="noLeftMargin()"
         [class.last]="isLast()">
      <img [alt]="publicationData().title" [ngSrc]="thumbnailImage" height="128" width="91">
      <div class="flex-column">
        @if (publicationData().publishDate) {
          <div class="date">{{ HELPER.formatDateWithLocalizedMonth(publicationData().publishDate) }}
          </div>
        }
        <div class="text-md text--semi-bold title">{{ publicationData().title }}</div>
        @if (hasDesc()) {
          <div class="text-sm description"
               [innerHTML]="publicationData().summary || publicationData().htmlDescription | removeHtml"></div>
        }
      </div>
    </div>
  </a>
}
